import { FlowProps } from '../controller/FlowProps/FlowProps';
import { mergeStyles } from './mergeStyles';
// This method is used only for migration purposes.
// It allows simply override public data for the flowAPI
// and returns an object which can be spread for setProps on user's side
export var createDangerousStylesOverride = function (flowAPI) { return function (styles) {
    var _a;
    flowAPI.controllerConfig.config.style.styleParams = mergeStyles(flowAPI.controllerConfig.config.style.styleParams, styles);
    return _a = {},
        _a[FlowProps.PropsMap.styles] = flowAPI.controllerConfig.config.style.styleParams,
        _a;
}; };
//# sourceMappingURL=createDangerousStylesOverride.js.map